module.exports = __webpack_public_path__ + "a0efa4c478135fa696323040c8c81faa.pdf";